<div class="print-container">
    <h1 class="page-label">Print Material</h1>
</div>

<div class="print-container">
    <div class="production-info card">
        <label class="production-info-label">Production Info</label>
        <div class="form-group card-body">
            <div class="production-info-input">
                <label for="batch-number-input">Batch Number</label>
                <input class="form-control" required [disabled]="formDisabled" [(ngModel)]="batchNumber" id="batch-number-input" type="text">
            </div>
            <div class="production-info-input">
                <label for="lot-number-input">LOT Number</label>
                <input class="form-control" required [disabled]="formDisabled" [disabled]="formDisabled" [(ngModel)]="lotNumber" id="lot-number-input" type="text">
            </div>
            <div class="production-info-input">
                <label for="pao-input">PAO</label>
                <input class="form-control" required [disabled]="formDisabled" [(ngModel)]="pao" id="pao-input" type="text">
            </div>
            <div>
                <label for="sku-input">Customer SKU</label>
                <input class="form-control" required [disabled]="formDisabled" [(ngModel)]="customerSku" id="sku-input" type="text">
            </div>
            <div>
                <label for="validation-date-input">Validation Date</label>
                <input class="form-control" required [disabled]="formDisabled" [(ngModel)]="validationDate" id="validation-date-input" type="text">
            </div>
        </div>
    </div>

    <div class="input-po">
        <input class="form-control" required [disabled]="formDisabled" [(ngModel)]="materialNumber" id="po-input" type="text" placeholder="Input Material Number">
    </div>
    <div class="print-input">
        <div class="table-controls">
            <button (click)="formDisabled? clearData() : loadData()" class="btn btn-primary">{{ formDisabled? 'Clear / Reset' : 'Load Data' }}</button>
        </div>
    </div>
    <ng-container *ngIf="formDisabled && dataloaded">
        <div class="production-info material-description">
            <span>{{materialDescription}}</span>
        </div>
        <div class="production-info bottom">
            <div class="printer-input">
                <select class="form-control" [(ngModel)]="selectedPrinter">
                    <option [ngValue]="null"> -- Choose RFID Printer -- </option>
                    <option *ngFor="let printer of availablePrinters; index as i" [ngValue]="printer">{{printer}}</option>
                </select>
            </div>
            <div class="uom-group">
                <div class="radio radio-default radio-inline" *ngFor="let uom of availableUoms; index as i">
                    <input type="radio" [(ngModel)]="selectedUom" name="uom-select" [value]="uom"  id="uom{{i}}">
                    <label for="uom{{i}}">
                        {{uom.unit_code}} <span>({{uom.pack_quantity}} ea)</span>
                    </label>
                </div> 
            </div>
            <div class="row">
                <div class="production-info-input">
                    <input class="form-control" type="number" inputmode="numeric" placeholder="Input Count of Copies" [(ngModel)]="quantity" id="quantity-input">
                </div>
                <button (click)="print()" [disabled]="isPrintBeingProcessed" class="submit btn btn-primary">Print All</button>
            </div>
            <div class="row">
                <h3 class="print-result success" *ngIf="printStatus === 'success'">Complete</h3>
                <h3 class="print-result error" *ngIf="printStatus === 'error'">Error</h3>
                <h3 class="print-result pending" *ngIf="printStatus === 'pending'">Pending</h3>
            </div>
        </div>
    </ng-container>    
</div>

<!-- Simple Indefinite Dialog - Used to display a progress indicator when performing actions. -->
<ef-simple-indefinite-progress-dialog
    >
</ef-simple-indefinite-progress-dialog>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>
